var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "mt-2 sm:mt-0 sm:col-span-2" }, [
    _c(
      "div",
      {
        staticClass:
          "max-w-lg flex justify-center px-6 pt-5 pb-6 border-2 border-gray-300 border-dashed rounded-md",
        on: {
          drop: function ($event) {
            $event.preventDefault()
            return _vm.addFiles.apply(null, arguments)
          },
          dragover: function ($event) {
            $event.preventDefault()
          },
        },
      },
      [
        _c(
          "div",
          { staticClass: "text-center" },
          [
            _c("ImageUploadIcon", {
              staticClass: "mx-auto h-12 w-12 text-gray-400",
            }),
            _c("p", { staticClass: "mt-1 text-sm text-gray-600" }, [
              _c("input", {
                ref: "fileUpload",
                attrs: { type: "file", hidden: "" },
                on: { change: _vm.changeFiles },
              }),
              _c(
                "button",
                {
                  staticClass:
                    "font-medium text-indigo-600 hover:text-indigo-500 focus:outline-none focus:underline transition duration-150 ease-in-out",
                  attrs: { type: "button" },
                  on: { click: _vm.chooseFiles },
                },
                [_vm._v(" Upload a file ")]
              ),
              _vm._v(" or drag and drop "),
            ]),
            _c("p", { staticClass: "mt-1 text-xs text-gray-500" }, [
              _vm._v(" PNG, JPG, GIF up to 10MB "),
            ]),
          ],
          1
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }